import * as React from 'react';
import { Query } from 'react-apollo';

import { compose } from 'recompose';

import connectToRouter from 'js/lib/connectToRouter';

import { getS12nAdjustedLearningHoursExperimentData } from 'bundles/s12n-common/api/learningHours';
import { useFetchLearningHours } from 'bundles/s12n-common/api/useFetchLearningHours';
import ConsumerBffSpecializationContext from 'bundles/unified-description-page-common/contexts/consumer/ConsumerBffSpecializationContext';
import ConsumerSpecializationPageQuery from 'bundles/unified-description-page-common/queries/bff/ConsumerSpecializationPageQuery.graphql';
import type {
  ConsumerSpecializationPageQuery as ConsumerSpecializationPageQueryType,
  ConsumerSpecializationPageQueryVariables,
} from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

type PropsToComponent = {
  slug: string;
  children: React.ReactNode;
};

const ConsumerBffSpecializationDataProvider = ({ slug, children }: PropsToComponent) => {
  const [learningHoursOverride, loadingLearningHours] = useFetchLearningHours(slug, 'S12N');
  return (
    <Query<ConsumerSpecializationPageQueryType, ConsumerSpecializationPageQueryVariables>
      query={ConsumerSpecializationPageQuery}
      variables={{ slug }}
      context={{ clientName: 'gatewayGql' }}
      errorPolicy="all"
    >
      {({ data, loading, error }) => {
        const specializationPageData = getS12nAdjustedLearningHoursExperimentData(
          data?.DescriptionPage?.querySpecializationPage,
          learningHoursOverride
        );

        return (
          <ConsumerBffSpecializationContext.Provider
            value={{
              specializationPage: specializationPageData,
              isS12nDataLoading: loading || loadingLearningHours,
              error,
            }}
          >
            {children}
          </ConsumerBffSpecializationContext.Provider>
        );
      }}
    </Query>
  );
};

export default compose<PropsToComponent, {}>(
  connectToRouter((router) => ({
    slug: router.params.productSlug,
  }))
)(ConsumerBffSpecializationDataProvider);
